<div class="images-container" [ngClass]="{'loading in': loading }">
	<div class="center">
		<div class="total-images-count" *ngIf="userPhotoCount?.totalPhotos == 1">{{ userPhotoCount?.totalPhotos }} photos</div>
		<div class="total-images-count" *ngIf="userPhotoCount?.totalPhotos != 1">{{ userPhotoCount?.totalPhotos }} photos</div>
		<div class="total-images-message">...total in your Photonomy network</div>
		<div class="total-images-button btn btn-default" (click)="navigate('/explore')" *ngIf="userPhotoCount?.myPhotos > 0">Explore photos</div>
		<div class="total-images-button btn btn-default" (click)="navigate('/photo/add/upload')" *ngIf="userPhotoCount?.myPhotos == 0">Add photos</div>
	</div>
</div>